import { render } from "./MappaturaP.vue?vue&type=template&id=0bd306dc&scoped=true"
import script from "./MappaturaP.vue?vue&type=script&lang=js"
export * from "./MappaturaP.vue?vue&type=script&lang=js"

import "./MappaturaP.vue?vue&type=style&index=0&id=0bd306dc&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd306dc"]])

export default __exports__